export const jnsWorks = {
  movie: [
    {
      id: 2,
      title: '야당',
      year: '2025',
      image: require('./movie/yadang-2025.webp')
    },
    {
      id: 1,
      title: '행복의 나라',
      year: '2024',
      image: require('./movie/1. 행복의나라.webp')
    },
    {
      id: 3,
      title: '서울의 봄',
      year: '2022',
      image: require('./movie/3. 서울의 봄.webp')
    },
    {
      id: 4,
      title: '마녀2',
      year: '2021',
      image: require('./movie/4. 마녀2.webp')
    },
    {
      id: 5,
      title: '해적2',
      year: '2020',
      image: require('./movie/5. 해적2.webp')
    },
    {
      id: 6,
      title: '아내를 죽였다',
      year: '2019',
      image: require('./movie/6. 아내를 죽였다.webp')
    },
  ],
  drama: [
    {
      id: 3,
      title: '애마',
      year: '2025',
      image: require('./drama/aema.webp')
    },
    {
      id: 4,
      title: '착한 여자 부세미',
      year: '2025',
      image: require('./drama/ms-incognito.webp')
    },
    {
      id: 1,
      title: '위기의X',
      year: '2022',
      image: require('./drama/1. 위기의X (드라마).webp')
    },
    {
      id: 2,
      title: '이태원 클라쓰',
      year: '2019',
      image: require('./drama/2. 이태원 클라쓰(드라마).webp')
    },
  ],
}
